import {Observable} from 'rxjs/Observable';
import {Injectable} from '@angular/core';
import {ParentService} from '../pages/A2-utils/ParentClass/ParentService';
import {Router} from '@angular/router';
import {Http} from '@angular/http';
import {constant} from '../app.constants';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class T2ThemeService extends ParentService {

  private hasSupportSource = new BehaviorSubject<boolean>(false);
  hasSupport$ = this.hasSupportSource.asObservable();

  constructor(private _router: Router, private _http: Http) {
    super();
  }

    public getUserProfile() {
        return this._http.get(constant.URL_USER_PROFILE, this.getHeader())
            .map(resp => resp.json())
            .catch(error => Observable.throw(error.json()));
    }
    public getMenuByRoleId(roleId) {
        return this._http.get(constant.URL_LIST_MENU + roleId , this.getHeader())
            .map(resp => resp.json());
    }

    public getProviderToken() {
        return this._http.get(constant.URL_SESSION_GET_TOKEN, this.getHeader() )
        .map(resp => resp.json())
        .catch((error: any) => Observable.throw(error.json()));
    }

    public getTokenUser(prov_token: string) {
      return this._http.get(constant.URL_PROVIDER_SESSION + prov_token).map(resp => resp.json());
    }

    getMessagesByUser() {
      const url = constant.URL_GET_MESSAGES_BY_USER;
      return this._http
        .get(url, this.getHeader())
        .map((resp) => resp.json());
    }

    public getTokenSetVersion() {
      return this._http.post(`${constant.URL_SESSION}/TokenJwt`, {} , this.getHeader())
          .map(resp => resp.json())
          .catch((error: any) => Observable.throw(error.json()));;
    }

  getConfigurationData(): Observable<any> {
    return this._http
      .get(`${constant.URL_CONFIGURATION_DATA}`, this.getHeader())
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  setSupportAvailability(available: boolean) {
    this.hasSupportSource.next(available);
  }
}



// WEBPACK FOOTER //
// ./src/app/trip2-theme/t2-theme.service.ts